import styled from 'styled-components'

const QuestionListItemDeleteUi = styled.span`
  cursor: pointer;
  color: red;
`

export default QuestionListItemDeleteUi
